import {
  Card,
  CardBody,
  Input,
  TableRow,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import RentalExportDataXlsx from "components/common/RentalExportExcel";
import DayRentalBasicRateTable from "components/dayRentalBasicRate/DayRentalBasicRateTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { useState, useContext, useEffect } from "react";
import DayRentalBasicRateServices from "services/DayRentalBasicRateServices";
import { FiPlus } from "react-icons/fi";
import DayRentalBasicRateDrawer from "components/drawer/DayRentalBasicRateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import sidebar from "routes/sidebar";

const DayRentalBasicRate = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const { data, loading, error } = useAsync(
    DayRentalBasicRateServices.getAllDayRentalBasicRate,
  );

  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

  const isAdmin = adminInfo?.id === 1;

  const hideView = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate day" && perm.view === 1,
  );

  const hideDelete = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate day" && perm.delete === 1,
  );

  const hideEdit = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate day" && perm.edit === 1,
  );

  const hideAdd = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate day" && perm.add === 1,
  );

  const hideExport = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate day" && perm.export === 1,
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const {
    dayRentalBasicRateRef,
    dataTable,
    serviceData,
    handleSubmitDayRentalBasicRate,
    currentPage,
  } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);
  const updatedData = safeData.map(({ id, ...rest }) => rest);
  // console.log("day rendal data", updatedData);

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const finalData = [];

  data?.data?.forEach((item, itemIndex) => {
    const vehicleIds = item.vehicle_type_id || [];
    const vehicleNames = item.vehicle_type_names || {};

    vehicleIds.forEach((vid, vehicleIndex) => {
      const primeValue = item.prime?.[vid];

      finalData.push({
        // City details only once per city
        "S.No.": vehicleIndex === 0 ? itemIndex + 1 : "",
        // ID: vehicleIndex === 0 ? (item.id ?? "") : "",
        // "State ID": vehicleIndex === 0 ? (item.state_id ?? "") : "",
        // State: vehicleIndex === 0 ? (item.state ?? "") : "",
        // "City ID": vehicleIndex === 0 ? (item.city_id ?? "") : "",
        // City: vehicleIndex === 0 ? (item.city ?? "") : "",

        // "S.No.": itemIndex + 1,
        ID: item.id,
        "State ID": item.state_id,
        State: item.state,
        "City ID": item.city_id,
        City: item.city,

        // Vehicle details
        "Vehicle ID": vid,
        "Vehicle Type": vehicleNames[vid] || vid,

        // Day rental rates
        "Min KM": item.min_km?.[vid] ?? "",
        "Min Rate": item.min_rate?.[vid] ?? "",
        "Extra KM": item.extra_km?.[vid] ?? "",
        "Night Allow": item.night_allowance?.[vid] ?? "",

        // Prime percentage
        Prime:
          primeValue !== undefined && primeValue !== null && primeValue !== ""
            ? `${primeValue}%`
            : "",

        // Status only on the first vehicle row
        Status:
          vehicleIndex === 0
            ? item.is_active == 0
              ? "Inactive"
              : "Active"
            : "",
      });
    });
  });

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <DayRentalBasicRateDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={dayRentalBasicRateRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    autoComplete="off"
                    name="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitDayRentalBasicRate}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Day Rental Rate
                  </Button>
                )}

                {hideExport && (
                  <RentalExportDataXlsx
                    exportDataXlsx={finalData}
                    fileNames="Day Rental Basic Rate"
                  />
                )}
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData.length ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <TableRow>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>Min KM</TableCell>
                        <TableCell>Min Rate</TableCell>
                        <TableCell>Extra KM</TableCell>
                        <TableCell>Night Allow.</TableCell>
                        <TableCell>Prime</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHeader>
                    <DayRentalBasicRateTable
                      dayRentalBasicRate={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Day Rental Basic Rates." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default DayRentalBasicRate;
